import React from "react";
import {
  Form,
  Input,
  DatePicker,
  Space,
  Button,
  Popconfirm,
  Divider,
  Card,
} from "antd";
import {
  CalendarOutlined,
  CloseOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { FORM_LAYOUT } from "../constants";

const { TextArea } = Input;

const FormPostponed = ({
  form,
  onFinish,
  onFinishFailed,
  onChangeDate,
  handleCancel,
}) => {
  return (
    <Card style={{ borderRadius: 8 }}>
      <Form
        {...FORM_LAYOUT}
        form={form}
        layout="horizontal"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Divider orientation="left">
          <CalendarOutlined /> เลื่อนนัดพิจารณา
        </Divider>

        <Form.Item
          label="วันนัดพิจารณาคดีใหม่"
          name="considerationDate"
          rules={[{ required: true, message: "โปรดเลือกวันที่เลื่อนนัด" }]}
        >
          <DatePicker
            showTime={{ format: "HH:mm" }}
            format="YYYY-MM-DD HH:mm"
            onChange={onChangeDate}
            placeholder="กรุณาเลือกวันที่และเวลา"
            size="large"
            style={{ width: "100%" }}
            disabledDate={(current) => {
              return current && current < dayjs().startOf("day");
            }}
          />
        </Form.Item>

        <Form.Item
          label="หมายเหตุ"
          name="memo"
          rules={[{ required: true, message: "โปรดกรอกหมายเหตุ" }]}
        >
          <TextArea
            rows={5}
            placeholder="กรอกเหตุผลในการเลื่อนนัด"
            showCount
            maxLength={500}
          />
        </Form.Item>

        <Form.Item wrapperCol={{ span: 24 }}>
          <div style={{ textAlign: "center", marginTop: 32 }}>
            <Space size="large">
              <Button
                size="large"
                onClick={handleCancel}
                icon={<CloseOutlined />}
                style={{ minWidth: 120 }}
              >
                ปิด
              </Button>
              <Popconfirm
                placement="topLeft"
                title="อัพเดทสถานะ"
                description="กรุณาตรวจสอบข้อมูลให้เรียบร้อย !"
                onConfirm={() => form.submit()}
                okText="ยืนยัน"
                cancelText="ปิด"
                okButtonProps={{ size: "large" }}
                cancelButtonProps={{ size: "large" }}
              >
                <Button
                  type="primary"
                  size="large"
                  icon={<SaveOutlined />}
                  style={{ minWidth: 120 }}
                >
                  บันทึก
                </Button>
              </Popconfirm>
            </Space>
          </div>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default FormPostponed;
